module.exports = __webpack_public_path__ + "img/buddy_hairs.2d2dddcb.svg";